import React from 'react'
import Fotter from './Fotter'

const HelpSupport = () => {
  return (
    <div>
      <Fotter/>
    </div>
  )
}

export default HelpSupport